import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

export default function EditButton(props: IProps) {
  const [open, setOpen] = useState(false);
  function handleMouseOver() {
    if (open === false) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    if (open === true) {
      setOpen(false);
    }
  }
  return (
    <Tooltip title="edit" arrow placement="bottom" open={open}>
      <IconButton
        aria-label="edit"
        onClick={props.onClick}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
}
